import React from 'react'

const Footer = () => {
  return (
   <>
   <div className='bg-gradient-to-b from-gray-800 to-black w-full border-t border-gray-700'>
    <div className='max-w-screen-lg p-4 mx-auto flex justify-center w-full'>

    <p className='text-white'>&copy; Copyright by Shehbaz Ali || All Rights Reserved.</p>
    </div>

   </div>
   </>
  )
}

export default Footer